import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class RolePermissionService {
  private service = "api/Module"; //Controller Name
  constructor(private http: Http,
    private cookieService: CookieService) { }
 
  GetModulesWithRoleAccess(id:string) {
    return this.http
      .get(`${this.service}/GetModulesWithRoleAccess?id=` + id, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetRolePermissions(name: string) {
    return this.http
      .get(`${this.service}/GetRolePermissions?jwToken=` + this.cookieService.get("Login") + "&name=" + name, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSideBarPermissions() {
    return this.http
      .get(`${this.service}/GetSideBarPermissions?jwToken=` + this.cookieService.get("Login"), {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateRoleModules(id: string, moduleIds: number[]) {
    return this.http
      .post(`${this.service}/UpdateRoleModules?id=` + id, moduleIds, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/role/role-permission.service.ts